import React, { useEffect, useState } from "react";

import "./Aside.scss";
import { FilterWrapper } from "../../assets/styles/FilterStyle";
import { FaBars } from "react-icons/fa";
import { getBankList, sendMoneyRequest, verifyAccount } from "../../utils/api";
import {
  isAlphabet,
  isEmpty,
  isNumber,
  numberToWords,
} from "../../utils/common";
import Spinner from "../spinner/Spinner";
import { AlertWrapper } from "../Modal/style";
import Receipt from "../Receipt/Receipt";
import Select from "react-select"

const initialFormData = {
  accountNumber: "",
  beneficiaryID: "",
  beneficiaryName: "",
  ifscCode: "",
  merchantId: "",
  mobileNumber: "",
  remittanceAmount: "",
  remarks: "",
  latitude: "24.034401",
  longitude: "74.780403",
  bankName: "",
  route: "IMPS",
  mode: "DIOSM",
  bankId: "",

};
const initialFormDataErr = {
  accountNumber: "",
  beneficiaryID: "",
  beneficiaryName: "",
  ifscCode: "",
  merchantId: "",
  mobileNumber: "",
  remittanceAmount: "",
  mode: "",
  bankName: ""
};
function AsideLeft({ data = [], close = () => { }, refresh = () => { }, payoutData = {}, userName }) {
  const [fromData, setFromData] = useState({ ...initialFormData });
  const [fromDataErr, setFromDataErr] = useState(initialFormDataErr);
  const [verifyLoader, setVerifyLoader] = useState(false);
  const [verify, setVerify] = useState(false);
  const [bankList, setBankList] = useState([]);
  const [loding, setLoding] = useState(false);
  const [cls, setCls] = useState("");
  const [message, setMessage] = useState({});
  const [verifyResp, setVerifyResp] = useState({});
  const [responceData, setResponceData] = useState({});
  const [isFocused, setIsFocused] = useState(null);
  const closeBox = () => {
    setCls(" active wait");
    setTimeout(() => {
      close(false);
    }, 300);
  };

  useEffect(() => {
    getBankList().then((resp) => {
      setBankList(resp?.data?.data);
    });
    setTimeout(() => {
      setCls("active");
    });
  }, []);

  let regifsc = new RegExp(/^[A-Z]{4}0[A-Z0-9]{6}$/);

  const ckeckError = () =>{

     let error = {};

    if (isEmpty(fromData.mode)) {
      error = { ...error, mode: "Please select debit account" };
    }

    if (isEmpty(fromData.beneficiaryName)) {
      error = { ...error, beneficiaryName: "Please enter beneficiary name" };
    }
    if (isEmpty(fromData.accountNumber)) {
      error = { ...error, accountNumber: "Please enter account number" };
    }
    // if (isEmpty(fromData.bankName)) {
    //   error = { ...error, bankName: "Please select bank" };
    // }
    if (isEmpty(fromData.ifscCode)) {
      error = { ...error, ifscCode: "Please enter ifsc" };
    } else if (regifsc.test(fromData.ifscCode) != true) {
      error = { ...error, ifscCode: "Please enter the valid format of ifsc" };
    }
    if (isEmpty(fromData.remittanceAmount)) {
      error = { ...error, remittanceAmount: "Please enter amount" };
    }
   return error
  }
  const onSubmit = () => {
   const error = ckeckError();
    setFromDataErr({ ...fromDataErr, ...error });

    if (isEmpty(error)) {
      const params = {
        name: fromData.beneficiaryName,
        accountNumber: fromData.accountNumber,
        bankIfsc: fromData.ifscCode,
        transferMode: fromData.route,
        transferAmount: fromData.remittanceAmount,
        latitude: "24.034401",
        longitude: "74.780403",
        remarks: isEmpty(fromData.remarks) ? " " : fromData.remarks,
        txnMode: "PAY_OUT",
        txnFlag: fromData.mode,
        clientCode: fromData.mode,
      };
      setLoding(true);

      sendMoneyRequest(params).then((response) => {

        setLoding(false);
        if (response?.data?.success) {
          setResponceData(response?.data?.data);
          setFromData({ ...initialFormData });
          refresh("refresh");
        } else {
          let msg = "";
          if (response?.data?.errorCodeList.length > 0) {
            msg = response?.data?.errorCodeList[0];
          } else {
            msg = response?.data?.msg;
          }
          setMessage({ msg: msg, type: "error" });
        }
      });
    }
  };

  function onchangeHandler(e) {
    const name = e.target.name;
    const value = e.target.value;

    if (name === "beneficiaryName") {
      if (!isAlphabet(value) && !isEmpty(value)) {
        return;
      }
    }
    if (name === "remittanceAmount") {
      if (!isNumber(value) && !isEmpty(value)) return;
      if (value == "0") return;
    }

    if (name === "remittanceAmount" && value > 500000) {
      return;
    }

    if (name === "ifscCode") {
      let upperCase = value.toUpperCase();
      setFromData({ ...fromData, [name]: upperCase });
    }

    if (name === "bankName") {
      const bank = bankList.find(item => item.bankName === value);
      setFromData({ ...fromData, [name]: value, bankId: bank?.bankId });
    } else {
      setFromData({ ...fromData, [name]: value });
    }

    setFromDataErr({ ...fromDataErr, [name]: "" });
  }

  const routeHandler = (routeType) => {
    setFromData({ ...fromData, route: routeType });
    setFromDataErr({ ...fromDataErr, route: "" });
  };

  const onCloseModal = () => {
    setResponceData({});
    closeBox()
  };

  useEffect(() => {
    setFromData({
      accountNumber: payoutData?.accountNumber || "",
      beneficiaryID: "",
      beneficiaryName: payoutData?.accountHolderName || "",
      ifscCode: payoutData?.accountIfscCode || "",
      merchantId: "",
      mobileNumber: "",
      remittanceAmount: "",
      mode: "",
      remarks: "",
      latitude: "24.034401",
      longitude: "74.780403",
      mode: "DIOSM",
      route: payoutData?.route || "IMPS",
    })
    console.log("payoutData", payoutData)
  }, [payoutData])



  const verifyBankAccount = () => {


    let error = {}

     if (isEmpty(fromData.accountNumber)) {
      error = { ...error, accountNumber: "Please enter account number" };
    }
    if (isEmpty(fromData.bankName)) {
      error = { ...error, bankName: "Please select bank" };
    }
    if (isEmpty(fromData.ifscCode)) {
      error = { ...error, ifscCode: "Please enter ifsc" };
    } else if (regifsc.test(fromData.ifscCode) != true) {
      error = { ...error, ifscCode: "Please enter the valid format of ifsc" };
    }

     setFromDataErr({ ...fromDataErr, ...error });

    if(!isEmpty(error)) return;


    const params = {
      accountNo: fromData.accountNumber || "",
      ifsc: fromData.ifscCode,
      bankId: fromData?.bankId,
      bankName: fromData.bankName,
      senderMobile: userName,
      lattitude: "24.034401",
      longitude: "24.034401",
      refferenceID: ""
    };

  
    setVerifyLoader(true);
 
    verifyAccount(params).then((resp) => {
      setVerifyLoader(false)
      console.log("success",resp)
      if (resp?.data.success) {
        setVerify(true);
        setVerifyResp(resp?.data?.data);
          setFromData({ ...fromData, "beneficiaryName": resp?.data?.data?.beneName });
        setMessage({type:"success", msg:"Account verified successfully"})
      } else {
        let msg = resp?.data?.msg;
        if(!isEmpty(resp?.data?.errorCodeList)){
       msg = resp?.data?.errorCodeList.toString()
        }
         setMessage({type:"error", msg:msg})

      }
    }).catch(() => {
      setMessage({type:"error", msg:"Something went wrong"})
      setVerifyLoader(false)
    })
  }

  const bankOptions = bankList?.map((val) => ({
  label: val.bankName,
  value: val.bankName,
}))

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    width: "100%",

    minHeight: "40px",
    height: "40px",
    padding: "0 8px",
    boxShadow: "rgba(0, 41, 112, 0.15) 0px 1px 2px",
    borderRadius: "5px",
    backgroundColor: "#fff",
    fontSize: "12px",
    border: "1px solid transparent",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      border: "1px solid #ccc",
    },
  }),

  valueContainer: (provided) => ({
    ...provided,
    padding: "0",
  }),

  input: (provided) => ({
    ...provided,
    margin: "0",
    padding: "0",
  }),

  indicatorsContainer: (provided) => ({
    ...provided,
    height: "40px",
  }),

  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "4px",
  }),

  clearIndicator: (provided) => ({
    ...provided,
    padding: "4px",
  }),

  menu: (provided) => ({
    ...provided,
    fontSize: "12px",
    zIndex: 9999,
  }),

  option: (provided, state) => ({
    ...provided,
    fontSize: "12px",
    backgroundColor: state.isFocused ? "#f2f2f2" : "#fff",
    color: "#000",
    cursor: "pointer",
  }),
};

const paymentOptions = [
  { value: "DIOSM", label: "DPay" },
  { value: "MOBIFAST", label: "MPay" },
  { value: "INSTANT_PAY", label: "IPay" },
  { value: "ROUND_PAY", label: "RPay" },
  { value: "EKO", label: "EPay" },
  { value: "KVM", label: "KPay" },
  { value: "RAZORPAY", label: "Razorpay" },
  { value: "AXIS_BANK", label: "Axis Bank" },
];

  return (
    <aside className={`aside-payout flex ${cls} `}>
      {!isEmpty(message) && (
        <AlertWrapper className={`${message?.type} globle`}>
          <span className="close" style={{top:"20px"}} onClick={() => setMessage({})}>
            ×
          </span>
          {
            message.type === "success"?
            <>
            Account verified successfully
            <div style={{padding:"16px",margin:"4px",borderRadius:"8px",background:"#fff",width:"100%", minWidth:"260px"}}>
                <p style={{display:"flex",justifyContent:"space-between",gap:"20px"}}><strong style={{color:"#000"}}>Beneficiary Name:</strong> <span style={{color:"#000"}}>{verifyResp?.beneName}</span></p>
            </div>
            </>
            :message?.msg || "Something went wrong"
          }
          
        </AlertWrapper>
      )}
      <div className="grow-1" ></div>

      <div className="aside">
        <FilterWrapper  className={`display_data`}>
          <div className="filterBox">
            <div>
              <div className="top flex gap-10 justify-between align-items closeButton">
                <FaBars onClick={() => closeBox()} style={{cursor:"pointer"}} />
              </div>
              <div className="flex align-items gap-20 mainBox">
                <div className="input-field">
                   <Select
    options={paymentOptions}
    value={paymentOptions?.find(
      (opt) => opt.value === fromData?.mode
    )}
    styles={customStyles}

    onChange={(selected) =>
      onchangeHandler({
        target: { name: "mode", value: selected?.value },
      })
    }
    placeholder="Select Debit Account"
    isSearchable
  />
                

                  <label htmlFor="" className="active">Select Debit Account</label>
                  {fromDataErr.mode && (
                    <p className="error fs-12 mt-10">{fromDataErr.mode}</p>
                  )}

                </div>


                <div className="input-field">
                  <input
                    type="text"

                    id="beneficiaryName"
                    name="beneficiaryName"
                    value={fromData?.beneficiaryName}
                    onChange={onchangeHandler}

                  />
                  <label htmlFor="beneficiaryName">Beneficiary Name</label>
                  {fromDataErr.beneficiaryName && (
                    <p className="error fs-12 mt-10">
                      {fromDataErr.beneficiaryName}
                    </p>
                  )}
                </div>
                <div className="input-field ">
                  <input
                    type="text"
                    id="accountNumber"
                    name="accountNumber"
                    value={fromData?.accountNumber}
                    onChange={onchangeHandler}

                  />
                  <label htmlFor="accountNumber">Account Number</label>

                  {fromDataErr.accountNumber && (
                    <p className="error fs-12 mt-10">
                      {fromDataErr.accountNumber}
                    </p>
                  )}
                </div>

          

                <div className="input-field">
  <Select
    options={bankOptions}
    value={bankOptions?.find(
      (opt) => opt.value === fromData?.bankName
    )}
    styles={customStyles}
 onFocus={() => setIsFocused(true)}
    onBlur={() => setIsFocused(false)}
    onChange={(selected) =>
      onchangeHandler({
        target: { name: "bankName", value: selected?.value },
      })
    }
    placeholder="Select Bank"
    isSearchable
  />

  <label className="active">Bank Name (optional)</label>

  {fromDataErr.bankName && (
    <p className="error fs-12 mt-10">{fromDataErr.bankName}</p>
  )}
</div>

                <div className="input-field verifyContainer">
                  <input
                    type="text"
                    name="ifscCode"
                    id="ifscCode"
                    value={fromData?.ifscCode}
                    onChange={onchangeHandler}

                  />
                  <label htmlFor="ifscCode">IFSC</label>
                  <button className={verify ? "vefify" : ""} onClick={verifyBankAccount}>
                    {
                      verifyLoader ? <div className="VerifyLoader"> </div>
                        : verify ?
                          <svg xmlns="http://www.w3.org/2000/svg" width="38" height="30" viewBox="0 0 24 24" fill="#0f8f4f">
                            <circle cx="12" cy="12" r="10" fill="#0f8f4f" />
                            <path d="M8 12l3 3 5-6" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>


                          : <span> Verify</span>


                    }
                  </button>
                  {fromDataErr.ifscCode && (
                    <p className="error fs-12 mt-10">{fromDataErr.ifscCode}</p>
                  )}
                </div>

                <div className="input-field">
                  <input
                    type="text"
                    id="remittanceAmount"
                    name="remittanceAmount"
                    maxLength={500000}
                    value={fromData?.remittanceAmount}
                    onChange={onchangeHandler}

                  />
                  <label htmlFor="remittanceAmount">Amount</label>
                  {fromDataErr.remittanceAmount && (
                    <p className="error fs-12 mt-10">
                      {fromDataErr.remittanceAmount}
                    </p>
                  )}

                  {(!isEmpty(fromData?.remittanceAmount) ||
                    fromData?.remittanceAmount != "0") && (
                      <p className="fs-12 mt-10" style={{ color: "#333" }}>
                        {" "}
                        {numberToWords(fromData?.remittanceAmount)}
                      </p>
                    )}
                </div>
                <div className="tabs flex">
                  <button
                    onClick={() => routeHandler("IMPS")}
                    className={fromData.route === "IMPS" && "active"}
                  >
                    IMPS
                  </button>
                  <button
                    onClick={() => routeHandler("NEFT")}
                    className={fromData.route === "NEFT" && "active"}
                  >
                    NEFT
                  </button>
                  <button
                    onClick={() => routeHandler("RTGS")}
                    className={fromData.route === "RTGS" && "active"}
                  >
                    RTGS
                  </button>
                </div>

                <p className="msg-text">
                  Max ₹5 lakh per transaction real time credit, work 24X7{" "}
                </p>

                <div className="input-field md-mb-50">
                  <input
                    type="text"
                    id="remarks"
                    name="remarks"
                    value={fromData?.remarks.trim()}
                    onChange={onchangeHandler}
                  />
                  <label htmlFor="remarks">Remarks(optional)</label>
                </div>

                <div className="input-field buttonContainer">
                  {!loding ? (
                    <button
                      className="userlist_btn "
                      style={{ width: "100%" }}
                      onClick={onSubmit}
                    >
                      Proceed
                    </button>
                  ) : (
                    <button
                      className="userlist_btn flex justify-center align-item "
                      style={{ width: "100%", gap: "10px" }}
                      disabled
                    //  onClick={onSubmit}
                    >
                      <Spinner /> <p>Processing</p>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </FilterWrapper>
        {!isEmpty(responceData) && (
          <Receipt modalData={responceData} onCloseModal={onCloseModal} />
        )}
      </div>
    </aside>
  );
}

export default AsideLeft;
